import { Form, Row, Col, Alert } from "react-bootstrap";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";

import registerImg from "../../Imge/undraw_email-consent_j36b.svg";
import {
  faEnvelope,
  faGraduationCap,
  faLock,
  faPhone,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ACADIMAC, baseURL, REGISTER } from "../../API/API";
import Lodingsubmit from "../../Components/Loding/Loding";

export default function Register() {
  const [FormData, SetForm] = useState({
    username: "",
    phoneNumber: "",
    parentPhoneNumber: "",
    schoolName: "",
    governorate: "",
    academicYear: "",
    email: "",
    password: "",
    confirmPassword: "",
    profileImage: "",
  });
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("رفع صورة شخصية");  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [success, SetSuccess] = useState("");
  const [message, Setmessage] = useState(false);
  const [academacData, setAcademacData] = useState([]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  //1/handel Submit
  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    if (FormData.password !== FormData.confirmPassword) {
      setLoading(false);
      setPasswordError("كلمة السر غير متطابقة");

      return;
    }

    try {
      const res = await axios.post(`${baseURL}/${REGISTER}`, FormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      setErr("");
      SetSuccess("");
      Setmessage(true);
      SetSuccess(res.data.Message);
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    } catch (err) {
      setLoading(false);
      Setmessage(false);
      setErr(err.response.data.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    async function handeldata() {
      await axios
        .get(`${baseURL}/${ACADIMAC}`)
        .then((response) => {
          setAcademacData(() => response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    handeldata();
  }, []);

  //1/handel Change
  function handleChanges(e) {
    const { name, value } = e.target;
    const updatedForm = { ...FormData, [name]: value };

    //1/ تحقق من تطابق كلمة السر وتأكيدها
    if (
      (name === "password" || name === "confirmPassword") &&
      updatedForm.password !== updatedForm.confirmPassword
    ) {
      setPasswordError("كلمة السر غير متطابقة");
    } else {
      setPasswordError("");
    }

    SetForm(updatedForm);
  }

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      SetForm({ ...FormData, profileImage: file });
    }
  };

  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="Authpage">
        <Header />

        <Row className="w-100">
          <Col md={4} className="imgform d-none d-md-block p-0">
            <img
              src={registerImg}
              alt="صورة تسجيل"
              className="img-fluid h-100 w-100"
              style={{ objectFit: "cover" }}
            />
          </Col>

          <Col
            xs={12}
            md={8}
            className="form-contant d-flex align-items-center justify-content-center bg-light"
          >
            <Form onSubmit={handleSubmit} className="Form w-75">
              <h3 className="titleForm mb-4 text-strart"> طلب إنشاء حساب : </h3>
              <p className="mb-4">
                ادخل بياناتك بشكل صحيح لضمان عدم حدوث مشاكل.
              </p>

              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  className="inpoutFeald"
                  type="text"
                  id="username"
                  name="username"
                  autoComplete="name"
                  value={FormData.username}
                  onChange={handleChanges}
                  placeholder=" "
                  required
                />
                <Form.Label htmlFor="username">
                  <FontAwesomeIcon className="iconeForm" icon={faUser} />
                  <span className="textinpout"> الاسم الرباعي</span>
                </Form.Label>
              </Form.Group>

              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald"
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  autoComplete="tel"
                  value={FormData.phoneNumber}
                  onChange={handleChanges}
                />
                <Form.Label htmlFor="phoneNumber">
                  <FontAwesomeIcon className="iconeForm" icon={faPhone} />
                  <span className="textinpout">رقم الهاتف</span>
                </Form.Label>
              </Form.Group>

              <div className="d-flex gap-3">
                <Form.Group className="floating-label-group mb-4 w-100">
                  <Form.Control
                    placeholder=" "
                    required
                    className="inpoutFeald"
                    type="text"
                    id="parentPhoneNumber"
                    name="parentPhoneNumber"
                    autoComplete="tel"
                    value={FormData.parentPhoneNumber}
                    onChange={handleChanges}
                  />
                  <Form.Label htmlFor="parentPhoneNumber">
                    <FontAwesomeIcon className="iconeForm" icon={faPhone} />
                    <span className="textinpout"> رقم ولي الأمر </span>
                  </Form.Label>
                </Form.Group>

                <Form.Group className="floating-label-group mb-4 w-100">
                  <Form.Control
                    placeholder=" "
                    required
                    className="inpoutFeald"
                    type="text"
                    id="schoolName"
                    name="schoolName"
                    autoComplete="organization"
                    value={FormData.schoolName}
                    onChange={handleChanges}

                  />
                  <Form.Label htmlFor="schoolName">
                    <FontAwesomeIcon
                      className="iconeForm"
                      icon={faGraduationCap}
                    />
                    <span className="textinpout"> اسم المدرسة</span>
                  </Form.Label>
                </Form.Group>
              </div>

              <Form.Group className="mb-3" controlId="governorate">
                <Form.Label htmlFor="governorate">المحافظة</Form.Label>
                <Form.Select
                  id="governorate"
                  required
                  className="custom-select"
                  name="governorate"
                  autoComplete="address-level1"
                  value={FormData.governorate}
                  onChange={handleChanges}
                >
                  <option value="">اختر المحافظة</option>
                  <option>القاهرة</option>
                  <option>الجيزة</option>
                  <option>الإسكندرية</option>
                  <option>القليوبية</option>
                  <option>المنوفية</option>
                  <option>الغربية</option>
                  <option>كفر الشيخ</option>
                  <option>البحيرة</option>
                  <option>دمياط</option>
                  <option>الدقهلية</option>
                  <option>الشرقية</option>
                  <option>بورسعيد</option>
                  <option>الإسماعيلية</option>
                  <option>السويس</option>
                  <option>شمال سيناء</option>
                  <option>جنوب سيناء</option>
                  <option>البحر الأحمر</option>
                  <option>الفيوم</option>
                  <option>بني سويف</option>
                  <option>المنيا</option>
                  <option>أسيوط</option>
                  <option>الوادي الجديد</option>
                  <option>سوهاج</option>
                  <option>قنا</option>
                  <option>الأقصر</option>
                  <option>أسوان</option>
                  <option>مطروح</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="academicYear">
                <Form.Label htmlFor="academicYear">الصف الدراسي</Form.Label>
                <Form.Select
                  id="academicYear"
                  required
                  className="custom-select"
                  name="academicYear"
                  autoComplete="education-level"
                  value={FormData.academicYear}
                  onChange={handleChanges}
                >
                  <option value="">اختر الصف الدراسي</option>
                  {academacData.map((res) => {
                    return <option value={res.id}>{res.name}</option>;
                  })}
                </Form.Select>
              </Form.Group>

              <Form.Group className="floating-label-group mb-4">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald"
                  type="email"
                  id="email"
                  name="email"
                  autoComplete="email"
                  value={FormData.email}
                  onChange={handleChanges}
                />
                <Form.Label htmlFor="email">
                  <FontAwesomeIcon className="iconeForm" icon={faEnvelope} />
                  <span className="textinpout"> البريد الإلكتروني</span>
                </Form.Label>
              </Form.Group>

              <div className="d-flex gap-3">
                <Form.Group className="floating-label-group mb-4 w-100" style={{ position: "relative" }}>
                  <Form.Control
                    placeholder=" "
                    required
                    className="inpoutFeald"
                    style={{ paddingLeft: "40px" }}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    autoComplete="new-password"
                    value={FormData.password}
                    onChange={handleChanges}
                  />
                  <Form.Label htmlFor="password">
                    <FontAwesomeIcon className="iconeForm" icon={faLock} />
                    <span className="textinpout">كلمة السر</span>
                  </Form.Label>
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "var(--nat-600)",
                    }}
                  >
                    {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                  </button>
                </Form.Group>

                <Form.Group className="floating-label-group mb-4 w-100" style={{ position: "relative" }}>
                  <Form.Control
                    placeholder=" "
                    required
                    className="inpoutFeald"
                    style={{ paddingLeft: "40px" }}
                    type={showConfirmPassword ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    autoComplete="new-password"
                    value={FormData.confirmPassword}
                    onChange={handleChanges}
                  />
                  <Form.Label htmlFor="confirmPassword">
                    <FontAwesomeIcon className="iconeForm" icon={faLock} />
                    <span className="textinpout">تأكيد كلمة السر</span>
                  </Form.Label>
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "var(--nat-600)",
                    }}
                  >
                    {showConfirmPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                  </button>
                  {passwordError && (
                    <div
                      className="invalid-feedback d-block"
                      style={{ color: "#dc3545", fontSize: "0.9rem" }}
                    >
                      {passwordError}
                    </div>
                  )}
                </Form.Group>
              </div>

              <Form.Group className="mb-3" controlId="uploadImage">
                <Form.Label>رفع صورة شخصية</Form.Label>

                <div className="upload-wrapper" onClick={handleClick}>
                  <div className="upload-display">{fileName}</div>
                  <button type="button" className="upload-button">
                    رفع
                  </button>
                  <input
                    id="profileImage"
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleChange}
                    style={{ display: "none" }}
                    aria-label="رفع صورة شخصية"
                    autoComplete="off"
                  />
                </div>
              </Form.Group>

              <button type="submit" className="btn_submit btn_small ms-auto">
                إنشاء حساب
              </button>
              {err && (
                <Alert variant="danger" style={{ marginTop: "20px" }}>
                  ❌ {err}
                </Alert>
              )}

              {success && (
                <Alert variant="success" style={{ marginTop: "20px" }}>
                  ✅ {success}
                </Alert>
              )}

              <Link to="#" target="_blank" className="btn_square_green">
                طريقة انشاء حساب على نوح اكاديمي
              </Link>
              <div className="mt-4">
                يوجد لديك حساب بالفعل؟
                <Link to="/login" className="text-decoration-none">
                  <span className="gold"> ادخل إلى حسابك الآن ! </span>
                </Link>
              </div>
            </Form>
          </Col>
        </Row>

        <Footer />
      </div>
    </>
  );
}
